import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './footer.css';

function Footer() {
    return (
    <footer className="footerStyle">
        <div className="container">
            <div className="row">
                {/* Coloana 1: Linkuri */}
                <div className="col-md-2">
                    <span className='footerTitles'>Navigation</span>
                    <ul className="list-unstyled">
                    <li><a href="/" className="itemsList">Home</a></li>
                    <li><a href="/about" className="itemsList">About</a></li>
                    <li><a href="/presetsluts" className="itemsList">Presets and LUTs</a></li>
                    <li><a href="/travel" className="itemsList">Travel</a></li>
                    <li><a href="/portfolio" className="itemsList">Portfolio</a></li>
                    </ul>
                </div>

                {/* Coloana 3: Rețele sociale */}
                <div className="col-md-2">
                    <span className='footerTitles'>See me</span>
                    <ul className="list-unstyled">
                    <li><a href="https://www.instagram.com/iulianamihai" className="itemsList">Instagram</a></li>
                    <li><a href="https://www.tiktok.com/iuliana.mihai" className="itemsList">TikTok</a></li>
                    <li><a href="https://www.facebook.com/IM.iulianamihai/" className="itemsList">Facebook</a></li>
                    <li><a href="https://ro.pinterest.com/iulianamihaii/" className="itemsList">Pinterest</a></li>
                    <li><a href="https://www.tumblr.com/iulianamihaii" className="itemsList">Tumblr</a></li>
                    <li><a href="https://www.deviantart.com/nebunelli" className="itemsList">DeviantArt</a></li>
                    </ul>
                </div>

                {/* column 4: contact info */}
                <div className="col-md-3">
                    <span className='footerTitles'>Contact me</span>
                    <ul className="list-unstyled">
                        <li className='itemsList'>Email: mihai.iuliana.im@gmail.com </li>
                        <br />
                        <li className='itemsList'>or DM to me on social media, Instagram or Facebook as you prefer.</li>
                    </ul>
                </div>

                {/* Coloana 5: Descriere scurtă */}
                <div className="col-md-4">
                    <span className='footerTitles'>About me</span>
                    <p className='itemsList'> I created this website as a way to connect with you, sharing my passions and experiences.
                        <br /> <br />My goal is to provide you a glimpse into my world, to show not just my work but also my thoughts that allows you to see me for who I truly am.
                        <br /> <br />I hope you find joy and inspiration here!
                    </p>
                </div>
            </div>
        </div>

        <div className="text-center py-3">
            <p className='footerRights'>&copy; 2025 Made by IULIANA MIHAI. All rights reserved.</p>
        </div>
    </footer>
    );
}

export default Footer;